import LoadingTable from "./LoadingTable";

export default LoadingTable;
